import { render, staticRenderFns } from "./TabletDeleteScreen.vue?vue&type=template&id=7a789ee9&scoped=true&lang=pug"
import script from "./TabletDeleteScreen.vue?vue&type=script&lang=ts"
export * from "./TabletDeleteScreen.vue?vue&type=script&lang=ts"
import style0 from "./TabletDeleteScreen.vue?vue&type=style&index=0&id=7a789ee9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a789ee9",
  null
  
)

export default component.exports